import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import { useAuth } from '../../../context/Auth';
import FilterCheckboxList, { FilterListItem } from './FilterCheckboxList';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    actingBodyId: number;
    onSelectCategory?: () => void;
}

export default function FinishReasonList({ value, setValue, actingBodyId, onSelectCategory }: Props) {
    const { user: authenticatedUser } = useAuth();
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function loadPageInfo() {
        if (actingBodyId === 0) {
            setItems([]);
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            const finishCategories = await dispatchService.getSimplifiedFinishReasons(actingBodyId);
            setItems(finishCategories.map((finishCategory) => ({
                label: finishCategory.name,
                value: finishCategory.id,
            })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        loadPageInfo();
    }, [actingBodyId, authenticatedUser]);

    return <FilterCheckboxList
        items={items}
        value={value}
        setValue={(newValue) => {
            onSelectCategory?.();
            setValue(newValue);
        }}
        isLoading={isLoading}
    />;
}
